import AccountIcon from '@mui/icons-material/AttachMoney';
import AccountList from './list';
import { AccountEdit } from './edit';
import { AccountCreate } from './create';
import { AccountShow } from './show';

export default {
    show: AccountShow,
    create: AccountCreate,
    list: AccountList,
    edit: AccountEdit,
    icon: AccountIcon,
};

